/*
auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("/modelli/vela_collo_3.glb");

  const { tessuto, club } = props;

  return (
    <group ref={group} {...props} dispose={null}>
      <group userData={{ name: "collo_0_Scene_Node" }} />
      <group userData={{ name: "collo_3b_Scene_Node" }}>
        <group userData={{ name: "Cloth.001" }}>
          <mesh
            material={materials["FABRIC 1_FRONT_23794"]}
            geometry={nodes.Collar_5_Node001.geometry}
            position={[0, 0.351, -0.046]}
            scale={[1.05, 1, 0.96]}
          >
            <meshStandardMaterial
              map={!club ? tessuto : null}
              roughness={1}
              toneMapped={false}
            />
          </mesh>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/modelli/vela_collo_3.glb");
